import React from 'react';
import CommerceCategoriesForm from 'forms/CommerceCategoriesForm';

export default (): JSX.Element => <CommerceCategoriesForm />;
